export default __webpack_public_path__ + "static/media/home-jcb.13a391fc.png";